import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from "react";
import { errorText, getActivityClusters, getDatesForPeriod, loadingText } from "../../custom_api/api";
import { emptyOpt, makeOpt } from "../../custom_utils/option";
import { ActivityCluster } from "../components/activity_cluster";
import { Jumbo } from "../components/jumbo";
import { RegionAndDateFilterWithDatePicker } from "../components/region_and_date_filter";
import { SearchBarWrapper } from "../components/search_bar";
import { QuickLinks } from "../components/quick_links";
import { Link } from "../components/library/link";
const activityClustersPageStateZero = {
    clusters: "loading"
};
const tomorrow = new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate() + 1}`);
export class ActivityClustersPage extends React.Component {
    componentDidMount() {
        window.parent.scrollTo({
            top: 0
        });
        this.updateResults(this.props, ()=>this.scrollToCluster(this.props.selectedCluster));
        document.title = this.props.pageTitle;
    }
    scrollToCluster(slug) {
        setTimeout(()=>{
            if (this.state.clusters != "error" && this.state.clusters != "loading") {
                let cluster = this.state.clusters.filter((c)=>c.slug === slug);
                if (!cluster.isEmpty()) {
                    let element = document.querySelector(`[data-anchor="${slug}"]`);
                    if (!element) return;
                    element.scrollIntoView({
                        behavior: "smooth"
                    });
                }
            }
        }, 500);
    }
    componentWillReceiveProps(nextProps) {
        const p = this.props;
        const np = nextProps;
        const scrollToCluster = ()=>p.selectedCluster != np.selectedCluster ? this.scrollToCluster(np.selectedCluster) : undefined;
        if (p.selectedPeriod == np.selectedPeriod && p.selectedRegion == np.selectedRegion) {
            scrollToCluster();
            return;
        }
        this.updateResults(np, ()=>scrollToCluster());
    }
    toggleArchive() {
        this.props.toggleArchive(()=>this.updateResults(this.props));
    }
    updateResults(props, cb) {
        this.setState((s, _)=>({
                ...s,
                clusters: "loading"
            }), ()=>{
            getActivityClusters({
                cluster: emptyOpt(),
                edition: emptyOpt(),
                region: makeOpt((q)=>props.selectedRegion ? q.Where((r)=>r.Slug.Equals(props.selectedRegion)) : q),
                activity: makeOpt((q)=>q.Where((a)=>a.HideInOverview.Equals(false))),
                location: emptyOpt(),
                event: makeOpt((q)=>this.props.showArchive ? q.Where((e)=>e.Date.IsBefore(tomorrow)) : q.Where((e)=>{
                        let period = getDatesForPeriod(props.selectedPeriod);
                        var startDate = period.start.toDate();
                        var utcStartDate = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000);
                        var endDate = period.end.toDate();
                        var utcEndDate = new Date(endDate.getTime() + endDate.getTimezoneOffset() * 60000);
                        return e.Date.IsAfter(utcStartDate).And(e.Date.IsBefore(utcEndDate));
                    }))
            }).then((x)=>{
                if (x != "error" && x != "loading") {
                    this.setState((s, _)=>({
                            ...s,
                            clusters: x
                        }), ()=>{
                        if (cb) cb();
                    });
                }
            });
        });
    }
    render() {
        const p = this.props;
        const s = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: p.headerTitle,
                    contents: p.description,
                    imageUrl: p.phImageUrl,
                    imageUrlFallback: p.phImageUrlFallback,
                    imageUrlLarge: p.phImageUrlLarge,
                    imageAlt: p.imageAlt,
                    size: "small",
                    kind: "activity"
                }),
                this.props.showArchive ? null : /*#__PURE__*/ _jsx(SearchBarWrapper, {
                    children: /*#__PURE__*/ _jsx(RegionAndDateFilterWithDatePicker, {
                        enabled: s.clusters != "loading" && s.clusters != "error",
                        selectedPeriod: p.selectedPeriod,
                        selectedRegion: p.selectedRegion,
                        selectPeriod: p.selectPeriod,
                        selectRegion: p.selectRegion,
                        regions: p.regions
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    "aria-live": "polite",
                    children: s.clusters == "loading" ? /*#__PURE__*/ _jsx("div", {
                        className: "container--mg align--center text--styled",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "weight--bold container--s",
                            children: loadingText
                        })
                    }) : s.clusters == "error" ? /*#__PURE__*/ _jsx("div", {
                        className: "container--mg align--center text--styled",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "weight--bold container--s",
                            children: errorText
                        })
                    }) : !s.clusters.isEmpty() && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "container--mg align--center",
                                children: /*#__PURE__*/ _jsx(QuickLinks, {
                                    title: "Direct naar...",
                                    links: s.clusters.map((cluster)=>({
                                            title: cluster.title,
                                            url: cluster.slug
                                        })).toList(),
                                    handleScroll: (slug)=>{
                                        p.selectCluster(slug);
                                        this.scrollToCluster(slug);
                                    }
                                })
                            }),
                            s.clusters.map((x, k)=>/*#__PURE__*/ _createElement(ActivityCluster, {
                                    ...x,
                                    key: `activity-cluster-${k}`
                                })).toArray()
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "container--mg align--center",
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            className: "button button--primary button--arrow",
                            onClick: ()=>this.toggleArchive(),
                            children: this.props.showArchive ? "Terug naar het actuele overzicht" : "Bekijk het archief"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            className: "link link--primary link--arrow",
                            url: "/terugblikken",
                            children: "Bekijk alle terugblikken"
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = activityClustersPageStateZero;
        this.updateResults = this.updateResults.bind(this);
    }
}
{}